<template>
  <div
    class="play_timer"
    :class="{ 'play_timer--no-label': hideLabel }"
    v-if="showTimer"
  >
    <div class="bar" :style="{ width: `${progressPercentage}%` }"></div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useTimerStore } from '@/stores/timerStore';

// Allow consumers to hide the BONUS TIMER label when using the timer
// outside of the gameplay bonus context (e.g., for asset preloading)
const props = defineProps<{ hideLabel?: boolean }>();

const timerStore = useTimerStore();

const progress = computed(() => timerStore.progress);
const showTimer = computed(() => timerStore.showTimer);

// Convert progress from 0-1000 scale to 0-100% for display
const progressPercentage = computed(() => {
  return Math.min(100, Math.max(0, timerStore.progress / 10));
});

const hideLabel = computed(() => !!props.hideLabel);
</script>
